/**
 * Vanta — Live Map / Crash heatmap (types partagés core <-> panel).
 * API : /vanta/crashmap/<live|heatmap|drops>
 */

export const crashMapDropCategories = ['player', 'resource', 'timeout', 'crash', 'security', 'unknown'] as const;
export type CrashMapDropCategory = typeof crashMapDropCategories[number];

export const crashMapCellSizes = [25, 50, 100, 200] as const;
export type CrashMapCellSize = typeof crashMapCellSizes[number];

export const crashMapRanges = ['24h', '7d', '30d', '90d', 'custom'] as const;
export type CrashMapRange = typeof crashMapRanges[number];

export type CrashMapLivePlayer = {
    id: number;
    name: string;
    x: number;
    y: number;
    z: number;
    heading: number;
    vehicle: boolean;
    alive: boolean;
};

export type CrashMapLiveResp = {
    ts: number;
    /** timestamp of the last positions update received from the server (0 = never) */
    updatedAt: number;
    stale: boolean;
    players: CrashMapLivePlayer[];
};

export type CrashMapCell = {
    /** cell index (floor(x / cell), floor(y / cell)) */
    cx: number;
    cy: number;
    /** cell center, GTA coordinates */
    x: number;
    y: number;
    count: number;
    /** player-hours spent in the cell during the range (presence sampling) */
    hours: number;
    /** value used for coloring: count, or drops per player-hour when normalized */
    weight: number;
    hot: boolean;
    cats: Partial<Record<CrashMapDropCategory, number>>;
};

export type CrashMapHeatmapSummary = {
    located: number;
    hotCells: number;
    maxPerCell: number;
    unlocated: number;
    massExcluded: number;
};

export type CrashMapHeatmapResp = {
    ts: number;
    from: number;
    to: number;
    cell: CrashMapCellSize;
    normalize: boolean;
    excludeMass: boolean;
    maxWeight: number;
    cells: CrashMapCell[];
    summary: CrashMapHeatmapSummary;
} | { error: string };

export type CrashMapDropEntry = {
    ts: number;
    name: string;
    license: string | null;
    category: CrashMapDropCategory;
    reason: string;
    resource?: string;
    x: number;
    y: number;
    z: number;
    mass: boolean;
};

export type CrashMapDropsResp = {
    total: number;
    drops: CrashMapDropEntry[];
} | { error: string };
